module.exports = __webpack_public_path__ + "img/money_bg.15aa3dd7.png";